
import React from "react";
import ColoredAISelector from "./ColoredAISelector";

interface AISelectorProps {
  selectedAI: "gemini" | "chatgpt" | "claude" | "deepseek";
  onAIChange: (value: "gemini" | "chatgpt" | "claude" | "deepseek") => void;
  disabled?: boolean;
}

const AISelector: React.FC<AISelectorProps> = ({ selectedAI, onAIChange, disabled = false }) => {
  return (
    <ColoredAISelector
      selectedAI={selectedAI}
      onAIChange={onAIChange}
      disabled={disabled}
    />
  );
};

export default AISelector;
